import { addDays, addYears, differenceInDays, format, isValid, parse, subMonths } from 'date-fns';
import { isNil } from 'ramda';

/**
 * Backwards convertation of toIsoData()
 * @param {String} input input date
 */
export const fromIsoDate = (input) => input && format(new Date(input), 'dd/MM/yyyy');

// Temporary workaround, it should be removed when BE returns single format of date. GEFKCL2-3901 GEFKCL2-4054
/**
 * Backwards convertation of toIsoDate() to date
 * @param {String} input input date
 */
export const toNormalDate = (input) => {
	const date = typeof input === 'string' ? input.substring(0, 10) : '';
	if (/^\d{4}\-\d{2}\-\d{2}$/.test(date)) {
		return format(new Date(date), 'dd/MM/yyyy');
	} else if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
		return date;
	} else if (/^\d{2}\.\d{2}\.\d{4}$/.test(date)) {
		return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd/MM/yyyy');
	} else {
		return `${date}`;
	}
};

/**
 * Backwards convertation of toIsoData() to date time
 * @param {String} input input date
 */
export const fromIsoDateTime = (input) => input && format(new Date(input), 'dd/MM/yyyy HH:mm:ss');

/**
 * Backwards convertation of toIsoData() to time
 * @param {String} input input date
 */
export const fromIsoTime = (input) => input && format(new Date(input), 'HH:mm');

/**
 * Convert date from 'DD/MM/YYYY HH:mm' (used on frontend) to 'YYYY-MM-DDTHH:mm:ss' (used by backend REST API).
 *
 * @param {String} input input date
 */
export const toIsoDateTime = (input) =>
	input && format(parse(input, 'dd/MM/yyyy HH:mm', new Date()), "yyyy-MM-dd'T'HH:mm:ss");

/**
 * (Try to) convert date with unknown format to 'YYYY-MM-DD HH:mm:ss.SSS' which is used in BE logs.
 *
 * @param {Date} input input date
 */
export const toBeLogDateTime = (input) => input && format(new Date(input), 'yyyy-MM-dd HH:mm:ss.SSS');

/**
 * Convert date with unknown format to Date format.
 *
 * @param input
 * @returns {*}
 */
export const stringToDate = (input) => input && format(new Date(input), 'dd/MM/yyyy');

/**
 * Compare two dates
 * @param {String} date1
 * @param {String} date2
 * @returns {number} difference in day
 */
export const dateDifference = (date1, date2) => {
	if (isNil(date1) || isNil(date2)) return null;

	const diff = differenceInDays(new Date(date2), new Date(date1));
	return diff;
};

export const isDate = (input) => input && isValid(new Date(input));
export const getTodayAsIso = () => format(new Date(), 'yyyy-MM-dd');
export const getExactlyXYearsAgoAsDateObj = (minusYears) => addYears(new Date(), minusYears);
export const getTommorowAsDateObj = () => addDays(new Date(), 1);
export const getDate3MonthsAgoAsDateObj = () => subMonths(new Date(), 3);
export const fromIsoDateToDate = (input) => input && new Date(input);
export const toIsoDateFormat = (input) => isDate(input) && format(new Date(input), 'yyyy-MM-dd');
